(function () {
    'use strict';

    angular
        .module('elogbooks.admin.service-provider-groups')
        .controller('ServiceProviderGroupsInfoController', ServiceProviderGroupsInfoController);

    ServiceProviderGroupsInfoController.$inject = ['serviceProviderGroupsResponse'];

    function ServiceProviderGroupsInfoController (serviceProviderGroupsResponse) {
        var vm = this;
        vm.group = serviceProviderGroupsResponse;
    }
})();
